<script setup lang="ts">
import { storeToRefs } from "pinia";

import {
  goToCompletionRoute,
  goToExpeditionRoute,
  goToPalletCheckerRoute,
  goToPickingRoute,
} from "@/services/apps/RouteService.ts";
import { appStore } from "@/stores/AppStore";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  appName: {
    type: String,
    default: null,
  },
  showIdleLink: {
    type: Boolean,
    default: true,
  },
  showSettingsLink: {
    type: Boolean,
    default: true,
  },
  showSignInLink: {
    type: Boolean,
    default: true,
  },
});
const store = appStore();
const { getEmployee } = storeToRefs(appStore());
const signOutFromDevice = (): void => {
  if (getEmployee.value === null) return;
  store.signOutFromDevice(props.appName, getEmployee.value);
  handleRouteClick("SIGNIN");
};

const handleRouteClick = async (routeName: string): Promise<void> => {
  if (props.appName === "picking") {
    await goToPickingRoute(routeName);
  } else if (props.appName === "completion") {
    await goToCompletionRoute(routeName);
  } else if (props.appName === "expedition") {
    await goToExpeditionRoute(routeName);
  } else if (props.appName === "palletChecker") {
    await goToPalletCheckerRoute(routeName);
  }
};

const refresh = (): void => {
  window.location.reload();
};
</script>

<template>
  <header class="bg-neutral-950 px-4 lg:px-8 py-4 flex items-center sticky top-0 left-0 z-50">
    <div class="flex items-center sm:flex-row flex-col">
      <h1 class="text-white text-xl lg:text-3xl font-normal">{{ title }}</h1>
    </div>
    <div class="ml-auto flex gap-3 items-center">
      <Button
        icon="text-xl! pi pi-refresh"
        class="text-black border-0 shadow-none bg-orange-400"
        rounded
        @click="refresh"
      />
      <Button
        v-if="showIdleLink"
        icon="text-xl! pi pi-home"
        class="text-black border-0 shadow-none bg-sky-500"
        rounded
        @click="handleRouteClick('IDLE')"
      />
      <Button
        v-if="showSettingsLink"
        icon="text-xl! pi pi-cog"
        class="text-white border-0 shadow-none bg-slate-800"
        rounded
        @click="handleRouteClick('SETTINGS')"
      />
      <Button
        v-if="getEmployee"
        icon="text-xl! pi pi-sign-out"
        class="bg-red-400 border-0 shadow-none text-black"
        rounded
        @click="signOutFromDevice"
      />
      <Button
        v-else-if="showSignInLink"
        icon="text-xl! pi pi-user"
        class="bg-green-400 border-0 text-black"
        rounded
        @click="handleRouteClick('SIGNIN')"
      />
    </div>
  </header>
</template>
